import { styled } from "@vitality-ds/system";
import baseFieldsetStyles from "./styles/BaseFieldset.styles";
export default styled("fieldset", baseFieldsetStyles);